import type { OpenOrderLineRecord } from '@navio/nsdk';
import type { StationaryService } from '../types/stationaryBooking';

export type StationarySummaryLineItem = {
  key: string;
  name: string;
  quantity: number;
  grossAmount: StationaryService['grossPrice'];
  originalGrossAmount?: StationaryService['originalGrossPrice'];
  priceListName?: StationaryService['priceListName'];
  discountPercent?: StationaryService['discountPercent'];
};

export function toStationarySummaryLineItems({
  primaryService,
  addonServices,
  openOrderLines
}: {
  primaryService: StationaryService | null;
  addonServices: StationaryService[];
  openOrderLines: OpenOrderLineRecord[];
}): StationarySummaryLineItem[] {
  return [
    ...(primaryService
      ? [
          {
            key: `primary-${primaryService.salesItemId}`,
            name: primaryService.name,
            quantity: 1,
            grossAmount: primaryService.grossPrice,
            originalGrossAmount: primaryService.originalGrossPrice,
            priceListName: primaryService.priceListName,
            discountPercent: primaryService.discountPercent
          }
        ]
      : []),
    ...addonServices.map((service) => ({
      key: `addon-${service.salesItemId}`,
      name: service.name,
      quantity: 1,
      grossAmount: service.grossPrice,
      originalGrossAmount: service.originalGrossPrice,
      priceListName: service.priceListName,
      discountPercent: service.discountPercent
    })),
    ...openOrderLines.map((line, index) => ({
      key: `open-${line.salesItemId ?? 'line'}-${index}`,
      name: line.name,
      quantity: line.quantity,
      grossAmount: line.grossAmount
    }))
  ];
}
